function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_AGENTS = '/agents';
const ROOTS_TEAMS = '/agents/teams';
const ROOTS_LOAN_OFFICERS = '/loan-officers';
const ROOTS_COMPANY_TRENDS = '/loan-officers/company-trends';
const ROOTS_OPPORTUNITIES = '/opportunities';

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
};

export const PATH_PAGE = {
  page404: '/404',
  page500: '/500',
  agents: {
    root: ROOTS_AGENTS,
    teams: {
      search: path(ROOTS_TEAMS, '/search'),
    },
    search: path(ROOTS_AGENTS, '/search'),
    lists: path(ROOTS_AGENTS, '/lists'),
  },
  loanOfficers: {
    root: ROOTS_LOAN_OFFICERS,
    companyTrends: {
      search: path(ROOTS_COMPANY_TRENDS, '/search'),
    },
    dashboard: path(ROOTS_LOAN_OFFICERS, '/dashboard'),
    search: path(ROOTS_LOAN_OFFICERS, '/search'),
    lists: path(ROOTS_LOAN_OFFICERS, '/lists'),
    trends: path(ROOTS_LOAN_OFFICERS, '/trends'),
  },
  opportunities: {
    root: ROOTS_OPPORTUNITIES,
    search: path(ROOTS_OPPORTUNITIES, '/search'),
    lists: path(ROOTS_OPPORTUNITIES, '/lists'),
  },
};

// TODO: Add correct PATH_DOCS url
export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
